import { useState, useRef, useEffect } from 'react';

function useHasPointerEvents(ref) {
  const [hasPointerEvents, setHasPointerEvents] = useState(true);
  const observerRef = useRef(null);
  useEffect(() => {
    const element = ref && "current" in ref ? ref.current : ref;
    if (!element) {
      return;
    }
    const checkPointerEvents = (el) => {
      const computedStyle = window.getComputedStyle(el);
      const pointerEventsValue = computedStyle.getPropertyValue("pointer-events");
      return pointerEventsValue !== "none";
    };
    setHasPointerEvents(checkPointerEvents(element));
    observerRef.current = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === "attributes" && (mutation.attributeName === "style" || mutation.attributeName === "class")) {
          setHasPointerEvents(checkPointerEvents(element));
        }
      }
    });
    observerRef.current.observe(element, {
      attributes: true,
      attributeFilter: [
        "style",
        "class"
      ]
    });
    observerRef.current.observe(document.body, {
      attributes: true,
      attributeFilter: [
        "style",
        "class"
      ]
    });
    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
        observerRef.current = null;
      }
    };
  }, [
    ref
  ]);
  return hasPointerEvents;
}

export { useHasPointerEvents };
//# sourceMappingURL=useHasPointerEvents.js.map
